import React from 'react';
import CustomizableDatagrid from '@zippity/ra-customizable-datagrid';
import { FormTab, SimpleForm, SimpleShowLayout, Tab, Datagrid } from 'react-admin';
import { useMediaQuery } from '@material-ui/core';
import { getZ3PConfigValue } from '../helper';

// https://reactjs.org/docs/higher-order-components.html

// This function takes a component (InnerComponent) such as CustomizableDatagrid or SimpleShowLayout.
// And it returns OuterComponent, which automatically applies defaultColumns and hiddenColumns.
function withFilteredColumns(InnerComponent) {
  const OuterComponent = ({ children, resource, ...otherProps }) => {
    const { default_columns, hidden_columns, sm_columns } = getZ3PConfigValue();
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const defaultColumns = isSmall
      ? sm_columns[resource] || []
      : default_columns[resource] || [];
    const hiddenColumns = hidden_columns[resource] || [];

    let filteredChildren = children;
    if (Array.isArray(children)) {
      filteredChildren = children.filter(
        (child) =>
          !child ||
          !child.props ||
          !child.props.source ||
          !hiddenColumns.includes(child.props.source),
      );
    }

    // Pass otherProps from OuterComponent to InnerComponent
    return (
      <InnerComponent
        defaultColumns={defaultColumns}
        resource={resource}
        {...otherProps}
      >
        {filteredChildren}
      </InnerComponent>
    );
  };
  return OuterComponent;
}

export const ZippityDatagrid = withFilteredColumns(CustomizableDatagrid);
export const ZippitySimpleForm = withFilteredColumns(SimpleForm);
export const ZippitySimpleShow = withFilteredColumns(SimpleShowLayout);
export const ZippityTab = withFilteredColumns(Tab);
export const ZippityFormTab = withFilteredColumns(FormTab);
